<h2>Detail</h2>

<div class="breadcrumb-container" data-cy="breadcrumb-banner">
  @for (breadcrumb of item().breadcrumbWithIds; track breadcrumb; let i = $index) {
    <span class="breadcrumb">
      @if (i !== 0) {
        <cue-icon [icon]="ICONS.cueArrowRight" />
      }
      <span class="part">{{ breadcrumb.item2 | localizedString }}</span>
    </span>
  }
</div>

<div class="detail-wrapper">
  <div class="room-info" data-cy="info-block">
    @if (schedule(); as currentSchedule) {
      <div class="schedule-status" [class.with-heading]="currentSchedule.subject || currentSchedule.organizer">
        <span
          class="status-tag"
          [style.background-color]="availabilityColor().backgroundColor"
          [style.color]="availabilityColor().color"
        >
          {{ availabilityText() | transloco }}
        </span>

        @if (currentSchedule.subject || currentSchedule.organizer) {
          <div class="schedule-heading">
            <span class="subject">{{ currentSchedule.subject }}</span>
            @if (currentSchedule.realStart && currentSchedule.realEnd) {
              <div class="organizer">
                <span class="label">{{ currentSchedule.realStart | date: 'dd.MM. HH:mm' }} - </span>
                <span class="value">{{ currentSchedule.realEnd | date: 'dd.MM. HH:mm' }}</span>
              </div>
            }
            @if (currentSchedule.organizer) {
              <div class="organizer">
                <span class="label">{{ translation.reservationPopup.organizer | transloco }}:</span>
                <span class="value">{{ currentSchedule.organizer }}</span>
              </div>
            }
          </div>
        }
      </div>
    }

    <table>
      @if (item().showCodeInDetail) {
        <tr>
          <th>
            <div>{{ translation.resourceDetail.qrCode | transloco }}</div>
          </th>
          <td>{{ item().qrCode }}</td>
        </tr>
      }

      @if (item().name | localizedString) {
        <tr>
          <th>
            <div>{{ translation.resourceDetail.name | transloco }}</div>
          </th>
          <td>{{ itemName() }}</td>
        </tr>
      }

      @if (item().qrCategoryName | localizedString) {
        <tr>
          <th>
            <div>{{ translation.resourceDetail.qrCategoryName | transloco }}</div>
          </th>
          <td class="text-w-icon">
            @if (item().qrCategoryIcon) {
              <img
                [src]="item().qrCategoryIcon"
                [class.img-cover]="item().imagePreferCover"
                [style.object-position]="item().imageObjectPosition"
                class="category-icon"
                alt=""
              />
            }
            {{ item().qrCategoryName | localizedString }}
          </td>
        </tr>
      }

      @if (item().resourceTypeName | localizedString) {
        <tr>
          <th class="text-w-icon">
            @if (item().resourceTypeIcon) {
              <img
                [src]="item().resourceTypeIcon"
                [class.img-cover]="item().imagePreferCover"
                [style.object-position]="item().imageObjectPosition"
                class="category-icon"
                alt=""
              />
            }
            {{ item().resourceTypeName | localizedString }}
          </th>
          <td>{{ parentResourceName() }}</td>
        </tr>
      }

      @if (item().isCapacityUnlimited) {
        <tr>
          <th>
            <div>{{ translation.resourceDetail.capacity | transloco }}</div>
          </th>
          <td>{{ translation.common.unlimited | transloco }}</td>
        </tr>
      }
    </table>

    @if (item().objects?.length > 0) {
      <cue-controllable-objects
        ignoreErrors="true"
        [objectList]="item().objects"
        [qrCodeId]="item().qrCodeId"
        [qrCodeListOfResource]="item().qrCodes | qrIdList"
      />
    }

    @if (item().resourceDescription | localizedString) {
      <div
        class="break-words custom-quill-styles"
        [innerHTML]="item().resourceDescription | localizedString | cueCustomUnsafeSanitize"
      ></div>
    }

    @if (item().unitInformation) {
      <hr />
      <cue-unit-detail [unitInfo]="item().unitInformation" />
    }

    @for (simpleFilter of simpleFilters(); track simpleFilter) {
      @if (
        simpleFilter.visible &&
        simpleFilter.value.value !== null &&
        simpleFilter.value.value !== undefined &&
        simpleFilter.value.value !== ''
      ) {
        <table>
          <tr>
            <th>
              <div class="text-w-icon">
                @if (simpleFilter.value.imageUrl) {
                  <img
                    [class.img-cover]="item().imagePreferCover"
                    [style.object-position]="item().imageObjectPosition"
                    [src]="simpleFilter.value.imageUrl | imageWidth: 30"
                    class="property-icon"
                    alt=""
                  />
                }
                {{ simpleFilter.name | localizedString }}
              </div>
            </th>
            <td>
              @if (simpleFilter.value.value === true) {
                <cue-icon [icon]="ICONS.cueCheck" class="correct" />
              } @else if (simpleFilter.value.value === false) {
                <cue-icon [icon]="ICONS.cueClose" class="incorrect" />
              } @else {
                <div
                  class="custom-html"
                  [innerHTML]="simpleFilter.value.value | localizedString | cueCustomUnsafeSanitize"
                ></div>
              }
            </td>
          </tr>
        </table>
      }
    }

    @for (enumerableFilter of enumerableFilters(); track enumerableFilter) {
      @if (enumerableFilter.visible) {
        <ul class="room-properties">
          <div class="item-label">{{ enumerableFilter.name | localizedString }}</div>
          @for (value of enumerableFilter.value; track value) {
            <li>
              <div class="img-wrapper">
                <img
                  [style.object-position]="item().imageObjectPosition"
                  [class.img-cover]="item().imagePreferCover"
                  [src]="value.imageUrl | imageWidth: 30"
                  alt=""
                />
              </div>
              <span class="description-text">{{ value.title | localizedString }}</span>
            </li>
          }
        </ul>
      }
    }
  </div>

  @if (item().audioUrl | localizedString) {
    <audio controls [src]="item().audioUrl | localizedString"></audio>
  }

  @if (item().files?.length > 0) {
    <hr />
  }
  <cue-file-gallery [files]="item().files" />
</div>
